module.exports = __webpack_public_path__ + "img/pager2-quick-icon7.9e59a6e7.png";